export const QUOTE_FILES_DOWNLOAD_STATUSES = {
  MISSING: 'missing',
  UPLOADING: 'uploading',
  READY: 'ready',
} as const;

export type QUOTE_FILES_DOWNLOAD_STATUSES =
  (typeof QUOTE_FILES_DOWNLOAD_STATUSES)[keyof typeof QUOTE_FILES_DOWNLOAD_STATUSES];

export type DownloadQuoteFilesQueryData = {
  status: QUOTE_FILES_DOWNLOAD_STATUSES;
  message: string | null;
  downloadUrl: string | null;
};

export type DownloadQuoteFilesQueryVars = {
  isFlatDownload: boolean;
};

export type DownloadQuoteFilesQueryParams = {
  quoteId: number;
};
